// front-end/src/utils/page-utils.js

// front-end/src/utils/page-utils.js

export function determinePageTitle(element) {
    // Сначала проверяем, находимся ли мы на странице новости

    if (window.location.pathname.match(/\/News(\.html)?$/)) {
        const urlParams = new URLSearchParams(window.location.search);
        const newsSlug = urlParams.get('slug');

        if (newsSlug) {
            // ИСПРАВЛЕНИЕ: Правильно формируем page title в зависимости от типа
            if (newsSlug.startsWith('case-')) {
                return `Case - ${newsSlug}`;
            } else {
                return `News - ${newsSlug}`;
            }
        }
    }

    // Проверяем, является ли элемент частью новостного блока
    const newsContext = findNewsContext(element);
    if (newsContext) {
        // ИСПРАВЛЕНИЕ: Определяем тип контекста
        if (newsContext.startsWith('case-')) {
            return `Case - ${newsContext}`;
        } else {
            return `News - ${newsContext}`;
        }
    }

    // Проверяем data-page атрибут элемента
    const elementPage = element.getAttribute('data-page');
    if (elementPage && elementPage !== 'Home') {
        // ИСПРАВЛЕНИЕ: Если уже содержит префикс, возвращаем как есть
        if (elementPage.startsWith('News - ') || elementPage.startsWith('Case - ')) {
            return elementPage;
        }
        return elementPage;
    }

    // Проверяем data-page у body
    const bodyPage = document.body.getAttribute('data-page');
    if (bodyPage && bodyPage !== 'Home') {
        // ИСПРАВЛЕНИЕ: Если уже содержит префикс, возвращаем как есть
        if (bodyPage.startsWith('News - ') || bodyPage.startsWith('Case - ')) {
            return bodyPage;
        }
        return bodyPage;
    }

    // Fallback
    return 'Home';
}

export function findNewsContext(element) {
  // Ищем родительский news-block
  let parent = element.parentElement;
  while (parent) {
    // Проверяем, есть ли у родителя атрибут data-block-name начинающийся с news-
    if (parent.hasAttribute('data-block-name')) {
      const blockName = parent.getAttribute('data-block-name');
      if (blockName && blockName.startsWith('news-')) {
        // Есть news-slug?
        const newsSlug = parent.getAttribute('data-news-slug');
        if (newsSlug) {
          return newsSlug;
        }
        // Используем имя блока
        return blockName;
      }
    }

    // Проверяем, есть ли у родителя класс news-block
    if (parent.classList && (parent.classList.contains('news-block') ||
        parent.classList.contains('news-preview'))) {
      const blockName = parent.getAttribute('data-block-name');
      if (blockName) {
        const newsSlug = parent.getAttribute('data-news-slug');
        return newsSlug || blockName;
      }
    }

    parent = parent.parentElement;
  }

  return null;
}

export function isNewsContext(element) {
  return findNewsContext(element) !== null;
}